export enum ApplicationSearchEventSource {
  Suggestions = 1,
  Header,
  ZeroResult,
  Filter,
  FilterUnselected,
  FilterRemoveAll,
  FilterRemove,
  AutoCorrection,
  Direct = 9
}
